$(document).ready(function(){
  $('.textfield, .select-widget, .textbox').on('focus, blur', function() {
    $(this).addClass("checked");
    if ($(this).val() == "")
      $(this).addClass("empty");
    else {
      $(this).removeClass("empty");
    }
  });

  $('.choice_h input, .choice_v input, .scale input').click(function() {
    var $parent_input = $(this).parent().parent();
    if($(this).is(":checked")){
      $parent_input.addClass("complete");
    }
    else if($(this).is(":not(:checked)")){
      $parent_input.removeClass("complete");
    }
  });
});
